import {historyMsgNum} from "../config/env";
import { store,  mutations} from '../store/index'
import socket from '../util/socket.io'
import {creatConversionDiv} from "@/util/util";

class VisitChat {
    constructor(visitorCode) {
        let _this = this;
        this.webSocketActivePingTimer = null;//激活心跳定时器
        this.webSocketActivePingTime = 180000;// 激活心跳的间隔，当前为 10秒
        this.visitBeatActiveType=2; //激活心跳的type值
        this.webSocketPingTimer = null;//激活心跳定时器
        this.webSocketPingTime = 5000;// 激活心跳的间隔，当前为 10秒
        this.visitBeatType=18;
        this.delayTimer = null;
        this.delayTime = 4000;
        this.delayTimerStatus = false;
        this.socketStatus = false;
        this.visitorCode = visitorCode;
        let startTime = new Date().getTime();
        this.socket = new socket(visitorCode,{
            onconnect:function(){
                console.info("socket连接成功");
                // mutations.saveLog('socket', '🔗socket连接成功,所用时间'+(new Date().getTime()-startTime)/1000)

                _this.socketStatus = true;
            },
            webSocketHandleMessage : function(e){
                _this.webSocketHandleMessage(e);
            },
            disconnect(){
                _this.socketStatus = false;
                clearTimeout(_this.webSocketPingTimer);
                clearTimeout(_this.webSocketActivePingTimer);
                if(store.Nim){
                    store.Nim.disconnect();
                    // store.Nim.connect()
                }
                // mutations.saveLog('socket', 'socket连接断开')


            },
            error(){
                _this.socketStatus = false;
                if(store.Nim){
                    store.Nim.disconnect();
                    // store.Nim.connect()
                }
                 // mutations.saveLog('socket', 'socket连接失败')
            },
            reconnect(){

            },

        });
    }


    //访客端历史消息
    vHisMsgLists(time){
        let a={
            //一次查询的数量限制
            limit:historyMsgNum,
            //是否按照消息时间升序，false代表降序
            asc:false,
            time:time||''
            //某个时间以上的消息
            //time:
        };
        console.info("获取历史消息的参数",a)
        let dat={
            //8 代表访客拉取历史消息
            type:4,
            data:JSON.stringify(a)
        };
        store.loadHistory = true;
        this.send(JSON.stringify(dat));
    }

    //访客端已读消息最后时间
    vLastTimes(time){
        //访客端已读消息最后时间
        let params={
            //最后已读消息时间戳
            lastReadTime:time
        };
        let dat={
            //3 代表访客端已读消息最后时间
            type:3,
            data:JSON.stringify(params)
        };
        console.info("发送已读回执",dat)
        this.send(JSON.stringify(dat));
    }

    //连接云信记录下来
    recodeImStatus(){
        let dat={
            type:19,
        };
        console.info("连接云信添加记录",dat)
        this.send(JSON.stringify(dat));
    }

    SubOnlineForm(){
        let dat={
            type:20,
        };
        console.info("提交表单成功",dat)
        this.send(JSON.stringify(dat));
    }

    // 定时心跳
    webSocketPing() {
        var _this= this;
        this.webSocketPingTimer = setTimeout(() => {
            // if (!_this.webSocketIsOpen) {
            //     return false;
            // }
            // console.log("心跳");
            const payload = {
                type:_this.visitBeatType
            };
            if( _this.socketStatus ){
                console.info("定时心跳")
                _this.send(JSON.stringify(payload))
            }
            //访客心跳


            clearTimeout(_this.webSocketPingTimer);
            // 重新执行
            _this.webSocketPing();
        }, _this.webSocketPingTime);
    }

    // 激活定时心跳
    webActiveSocketPing() {
        console.info("发送激活心跳")
        var _this= this;
        this.webSocketActivePingTimer = setTimeout(() => {
            // if (!_this.webSocketIsOpen) {
            //     return false;
            // }
            // console.log("心跳");
            const payload = {
                type:_this.visitBeatActiveType
            };
            //访客心跳
            if( _this.socketStatus ){
                console.info("发送激活心跳")
                _this.send(JSON.stringify(payload))
            }

            clearTimeout(_this.webSocketActivePingTimer);
            // 重新执行
            _this.webActiveSocketPing();
        }, _this.webSocketActivePingTime);
    }



    //收到数据的时候
    webSocketHandleMessage(res) {
        // let res = JSON.parse(event.data);
        // console.log("访客端端接收到的消息为:", res);
        if(res.type==0&&res.data.code=='001'){
            store.hasPushForm = false;
            store.hasPushPresetText = false;
            store.msgList = [];
            store.hasSubOnlineForm = res.data.hideForm;
            mutations.initForm();
            mutations.setServerReadLastTime(res.data.serverReadLastTime)
            mutations.setUnReadCount(res.data.unReadCount);
            mutations.sendPresetTxt();
            this.webActiveSocketPing()
            this.webSocketPing();
            // mutations.loginSuccess();
            this.vHisMsgLists();
            if(res.data.linkImToday==true){
                if(!store.Nim||store.NimStatus==false){
                    mutations.connectNim();
                }
            }
        }else if(res.type==5){  //消息历史
            if(res.data.code=='001') {
                mutations.dealHistoryMsg(res.data.messageList)
            }
        }else if(res.type==13){   //收到的第一条消息 开始连接网易云信
            mutations.setFirstMsgList(res.data.lastMsg)//开始连接网易云信
            if(!store.Nim||store.NimStatus==false){
                mutations.connectNim();
            }
        }else if(res.type==9){      //已读的时间
            mutations.setServerReadLastTime(res.data.lastReadTime)
        }else if(res.type==12){   //访客转移
            // this.delayTimerStatus = false;
            mutations.setServerData(res.data);
        }else if(res.type==14){    //访客端收到拉黑的消息
            mutations.setBlack(res.data.isBlack);
            console.info(res)
        }else if(res.type==25){    //客服当前状态      //防止访客状态频繁切换
            if(store.isLeaveMessage){
                mutations.setServerData(res.data);
            }
            // this.delayTimerStatus = true;
            // clearTimeout(this.delayTimer);
            // this.delayTimer = setTimeout(()=>{
            //     if(this.delayTimerStatus){
            //         mutations.setServerData(res.data);
            //         console.info("客服状态")
            //     }
            // },this.delayTime);
        }else if(res.type==28){   //通知多端连接im
            if(!store.Nim||store.NimStatus==false){
                mutations.connectNim();
            }
        }else if(res.type==34){
            if(store.conversionConfigId == 4){
                creatConversionDiv();
            }
        }

    }

    send(res){
        this.socket.send(res);
    }
    close(){
        this.socket.close()
    }
    connect(){
        this.socket.connect()
    }
}

export default VisitChat
